import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * A dead address, wherever it was reached from. Inside a workspace document the link
 * below leads back to the dashboard within that same tab, so a mistyped address costs
 * the operator a tab rather than their arrangement.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section className="not-found-page">
      <span className="not-found-page__code">404</span>
      <h1>{t('errors.notFoundTitle')}</h1>
      <p>{t('errors.notFoundMessage')}</p>
      <Link className="button button--primary" to="/console">{t('errors.returnDashboard')}</Link>
    </section>
  );
}
